(function () {

    var SHARE_API = 'https://api.flowerknows.co';

    // 之前只找 share-button，现在要同时支持新的 share-article-block
    function getShareRoot(el) {
        return el.closest('share-button, .share-article-block');
    }

    function updateCountDisplay(root, count) {
        root.querySelectorAll('[data-share-count]').forEach(function (el) {
            if (count > 0) {
                el.textContent = count;
                el.classList.remove('hidden');
            } else {
                el.textContent = '';
                el.classList.add('hidden');
            }
        });
    }

    function buildUrl(root) {
        var handle = root.dataset.articleHandle;
        if (!handle) return null;
        return SHARE_API + '/api/shopify/articles/' + encodeURIComponent(handle) + '/shares';
    }

    function fetchCount(root) {
        var url = buildUrl(root);
        if (!url) return;

        fetch(url)
            .then(function (res) { return res.json(); })
            .then(function (data) { updateCountDisplay(root, data.share_count || 0); })
            .catch(function () { });
    }

    function reportShare(root, platform) {
        var url = buildUrl(root);
        if (!url) return;

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,
            body: JSON.stringify({ platform: platform })
        })
            .then(function (res) { return res.json(); })
            .then(function (data) { updateCountDisplay(root, data.share_count || 0); })
            .catch(function () { });
    }

    function initTracking() {
        // 同时初始化两种容器的计数展示
        document.querySelectorAll('share-button[data-article-handle], .share-article-block[data-article-handle]')
            .forEach(fetchCount);

        document.addEventListener('click', function (e) {
            // 原生 Web Share API 按钮（仅 share-button 会有）
            var nativeBtn = e.target.closest('.share-button__button');
            if (nativeBtn && !nativeBtn.classList.contains('hidden')) {
                var root = getShareRoot(nativeBtn);
                if (root) reportShare(root, 'native');
                return;
            }

            // share-button 的 fallback：复制链接
            var copyBtn = e.target.closest('.share-button__copy');
            if (copyBtn) {
                var r2 = getShareRoot(copyBtn);
                if (r2) reportShare(r2, 'copy');
                return;
            }

            // share-button 的 fallback 列表 + 新的 share-social 图标
            // 两者分别用不同 class，合并判断
            var socialLink = e.target.closest('.list-social__link, .share-article-block__link');
            if (socialLink) {
                var r3 = getShareRoot(socialLink);
                if (!r3) return;
                var platform = 'unknown';
                var href = socialLink.getAttribute('href') || '';
                if (href.indexOf('facebook.com') > -1) platform = 'facebook';
                else if (href.indexOf('twitter.com') > -1) platform = 'twitter';
                else if (href.indexOf('pinterest.com') > -1) platform = 'pinterest';
                else if (href.indexOf('whatsapp.com') > -1) platform = 'whatsapp';
                else if (href.indexOf('telegram.me') > -1) platform = 'telegram';
                else if (href.indexOf('mailto:') === 0) platform = 'email';
                reportShare(r3, platform);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTracking);
    } else {
        initTracking();
    }
})();